// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__v69Fe","flexContainer":"ProfileContent_flexContainer__Hw3M0"};